import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/services/event.service';
import { verifyLanguage } from 'src/app/shared/constants/app-enums';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  lang: any;
  currentTab: string = "";
  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024
  @ViewChild('rightPanel') rightPanel!: ElementRef; 

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService,
    private eventService: EventService
  ) {
    this.route.params.subscribe(params => {
      const lang = params['lang'];
      if (lang && verifyLanguage(lang)) {
        this.lang = lang;
      } else {
        const localLang = localStorage.getItem('currentlang');
        if (localLang && verifyLanguage(localLang)) {
          this.lang = localLang;
        } else {
          const userLang = navigator.language?.split('-')[0];
          this.lang = userLang && verifyLanguage(userLang) ? userLang : 'en';
        }
      }
    });
    this.translate.setDefaultLang(this.lang);
    this.translate.use(this.lang);
    this.eventService.setLang(this.lang);
  }
  
  ngOnInit(): void {
    this.subscriptions.push(this.eventService.scrollTopParent.subscribe(
      (cordinates:any) =>  {
        if(this.rightPanel?.nativeElement) {
          if(cordinates) {
            this.rightPanel.nativeElement.scrollTo(cordinates.x,cordinates.y);
          } else {
            this.rightPanel.nativeElement.scrollTo(0,0);
          }
        }
      }
    ));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  toggleSidebar() {
    this.eventService.sidebarState.emit();
  }
}
